import { buildHubEntity } from './marker_utils'

class HubMarker {
  constructor ({ cesiumViewer, serialNumber }) {
    this._cesiumViewer = cesiumViewer // May be null at construction time
    this._entity = null

    this.serialNumber = serialNumber
    this.name = null
    this.latitude = null
    this.longitude = null
  }

  get entity () {
    return this._entity
  }

  get hubId () {
    return 'hub_' + this.serialNumber
  }

  get hubName () {
    if (!this.name) {
      return 'Hub: ' + this.serialNumber
    }

    return this.name
  }

  get coordinates () {
    if (this.latitude !== null && this.longitude !== null) {
      return { latitude: this.latitude, longitude: this.longitude }
    }
    return null
  }

  update ({ name, router }) {
    if (name) this.name = name // Optional custom name

    if (router && router.latitude && router.longitude) {
      this.latitude = router.latitude
      this.longitude = router.longitude
    }

    this._refreshEntity()
  }

  _refreshEntity () {
    // Ensure we have the necessary data
    if (!this.coordinates) return

    const position = Cesium.Cartesian3.fromDegrees(this.longitude, this.latitude)

    if (this._entity) {
      // Update existing entity
      this._entity.position = position
      this._entity.name = this.hubName
    } else if (this._cesiumViewer) {
      // Create new entity
      this._entity = buildHubEntity({
        cesiumViewer: this._cesiumViewer,
        id: this.hubId,
        name: this.hubName,
        position
      })
    }
  }
}

export const withHubMarkers = (_controller, { cesiumViewer }) => {
  const hubMarkers = new Map()

  return {
    update: (hubData) => {
      const serialNumber = hubData.serial_number
      if (!serialNumber) return

      let hubMarker = hubMarkers.get(serialNumber)
      if (!hubMarker) {
        hubMarker = new HubMarker({ cesiumViewer, serialNumber })
        hubMarkers.set(serialNumber, hubMarker)
      }

      hubMarker.update(hubData)
    },
    getEntity: () => {
      // Return the first Hub Entity (for now)
      for (const hubMarker of hubMarkers.values()) {
        const entity = hubMarker.entity
        if (entity) return entity
      }
      return null
    },
    getCoordinates: () => {
      // Return the first Hub Position (for now)
      for (const hubMarker of hubMarkers.values()) {
        const coordinates = hubMarker.coordinates
        if (coordinates) return coordinates
      }
      return null
    }
  }
}
